import { Component, inject } from '@angular/core';
import { ENVIRONMENT_CONFIGURATION } from '@softwarehaus/util-angular-configuration';
import { NgClass, NgStyle } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NappEnvironmentConfiguration } from '~/app/config/environments-configuration';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  imports: [TranslateModule, NgClass, NgStyle],
})
export class FooterComponent {
  private config = inject<NappEnvironmentConfiguration>(ENVIRONMENT_CONFIGURATION);

  public footerConfig = {
    ...this.config.footer,
    phoneNrLink: this.config.footer.phoneNr.replace(/\s/g, ''),
    showSponsors: this.config.footer.type === 'sponsor' && Array.isArray(this.config.footer.sponsorLogos),
  };

  public getLogoCSSLink(logo: string) {
    return `url('assets/themes/${this.config.theme}/images/sponsors/${logo}.svg')`;
  }

  public getLogoCSSWidth(width: number) {
    return `${width}px`;
  }
}
